import { createServiceToken } from '@/app/di';
import type { OrganizationService } from './infrastructure/organization.service';
import type { CustomRolesService } from './infrastructure/custom-roles.service';

export const ORG_SERVICE = createServiceToken<OrganizationService>('OrganizationService');
export const CUSTOM_ROLES_SERVICE = createServiceToken<CustomRolesService>('CustomRolesService');
